import { Alert, Typography, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { useOpenHelp } from 'src/components/shared/HelpCenterButton';
export default function ManagerResourcesTab() {
  const openHelp = useOpenHelp();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageContainer
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('file_cabinet.manager_resources_information')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('file_cabinet.manager_resources_info_text'))), /*#__PURE__*/React.createElement("div", {
    className: classes.actionButtons
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => openHelp('notices addenda sample files', 'https://pro.livable.com/knowledge/notices-addenda-samplefiles'),
    size: "large",
    variant: "priority",
    'custom-attribute': '540-ManagerResourcesTab'
  }, t('file_cabinet.access_manager_resources'))));
}